import type { CSSProperties, ComponentProps } from 'react';
import { css, cx } from '../../../styled-system/css';
import { flex } from '../../../styled-system/patterns';
import type { BaseButtonProps } from '../Button/Button';
import { button, linkText } from '../../../styled-system/recipes';

export type AnchorProps =
  | ({ variant?: undefined } & ComponentProps<'a'>)
  | ({ variant?: 'button' } & ComponentProps<'a'> & BaseButtonProps);

/**
 * アンカーコンポーネント
 */
export function Anchor(props: AnchorProps) {
  if (props.variant === 'button') {
    const { children, color, size, width, stretch = 'text', className, ...rest } = props;
    return (
      <a
        className={cx(
          button({ color, size, stretch: width ? undefined : stretch }),
          className,
          width ? css({ width: 'var(--button-width)' }) : undefined,
          flex({ alignItems: 'center', justifyContent: 'center', textAlign: 'center' })
        )}
        // FIXME: プロパティ名の型が解決できない。CSSPropertiesへキャストして強制的に解決している
        style={width ? ({ '--button-width': `${width}px` } as CSSProperties) : undefined}
        {...rest}
      >
        {children}
      </a>
    );
  }

  const { children, className, ...rest } = props;
  return (
    <a className={cx(className, linkText())} {...rest}>
      {children}
    </a>
  );
}
